import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  formFieldNoteIcon: {
    marginRight: '.25rem',
    paddingTop: '.5rem'
  },
  formFieldNote: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  choseFile: {
    appearance: 'none',
    backgroundClip: 'padding-box',
    display: 'block',
    lineHeight: '1.5',
    width: '100%',
    '& .MuiInputBase-formControl': {
      width: '100%',
      padding: '0 1rem',
      input: {
        padding: 0,
        height: 'auto'
      }
    }
  },
  choseFileBtn: {
    position: 'absolute',
    right: '0rem',
    height: '2.5rem'
  },
  calanderPadding: {
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      paddingRight: '0.375rem'
    }
  },

  buttonInpuGroupBtn: {
    width: '40%',
    borderTopRightRadius: '0',
    borderBottomRightRadius: '0'
  },
  buttonInpuGroupInput: {
    width: '60%',
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      borderTopLeftRadius: '0',
      borderBottomLeftRadius: '0'
    }
  }
}));

export default useStyles;
